export function safeDecode(value: string, component = true): string {
  try {
    return component ? decodeURIComponent(value) : decodeURI(value);
  } catch {
    // 遇到非法编码，直接返回原始值
    return value;
  }
}
